/**
 * Centralized navigation labels for web and mobile.
 * Update these values to change labels across the app.
 */
export const NAV_LABELS = {
  directory: {
    mobileTab: 'Directory',
    webNav: 'Directory',
  },
  inbox: {
    mobileTab: 'Inbox',
    webNav: 'Inbox',
  },
  community: {
    mobileTab: 'Library',
    webNav: 'Inquiry Library',
  },
  contentLibrary: {
    mobileTab: 'Content Library',
    webNav: 'Content Library',
  },
  invites: {
    mobileTab: 'Invite',
    mobileTitle: 'Invite a Peer',
    webNav: 'Invite a Peer',
  },
  account: {
    mobileTab: 'Account',
    webNav: 'Account',
  },
  inquiry: {
    mobileTab: 'Inquiry',
    webNav: 'Ask an Expert',
  },
  fellows: {
    mobileTab: 'Fellows Corner',
    webNav: 'Fellows Corner',
  },
  medicalOnDemand: {
    mobileTab: 'Medical On Demand',
    webNav: 'Medical On Demand',
  },
} as const;

export type NavLabelKey = keyof typeof NAV_LABELS;
